import {ReactNode} from 'react';
import {
    Navigate,
    useLocation
} from "react-router-dom";
import {PlatformLoader} from "@flexinet/ui-components";
import {useAuth} from "../hooks/useAuth.ts";


export const RequireAuth = ({children}: { children: ReactNode }) => {
    const location = useLocation();
    const {
        user,
        authResolved
    } = useAuth();

    // FNP-1202: on a hard load (deep link, refresh, pasted URL) React paints
    // before AuthProvider's getCurrentUser() resolves, so `user` is undefined
    // for one render even for a signed-in admin. Redirecting on that render
    // sent every deep link to '/', which then bounced to /dashboard — the
    // requested URL was lost before the router ever matched it. Hold instead.
    if (!authResolved) {
        return <PlatformLoader/>;
    }

    if (!user) {
        // Carry the attempted destination so a sign-in can return to it,
        // rather than dropping the user on the home page.
        return <Navigate to="/" state={{from: location}} replace/>;
    }

    return children;
};
